import React from 'react';

interface WorkflowStepperProps<T extends string> {
    steps: { key: T; label: string }[];
    currentStep: T;
    onStepClick: (step: T) => void;
    onPrev: () => void;
    onNext?: () => void;
    nextLabel?: string;
    showNext?: boolean;
}

export const WorkflowStepper = <T extends string>({
    steps,
    currentStep,
    onStepClick,
    onPrev,
    onNext,
    nextLabel = 'Next Step',
    showNext = true,
}: WorkflowStepperProps<T>) => {
    return (
        <div className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100 px-3 sm:px-6 lg:px-8 py-2 sm:py-3">
            <div className="max-w-[1600px] mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
                <div className="overflow-x-auto scrollbar-hide -mx-3 pl-14 pr-3 py-1 sm:mx-0 sm:px-0 sm:py-0">
                    <div className="flex items-center space-x-1 bg-gray-50/50 p-1 rounded-xl border border-gray-100 w-max">
                        {steps.map((s) => (
                            <button
                                key={s.key}
                                onClick={() => onStepClick(s.key)}
                                className={`px-3 sm:px-5 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-all whitespace-nowrap ${currentStep === s.key ? 'bg-white text-gray-900 shadow-sm border border-gray-100' : 'text-gray-400 hover:text-gray-600'
                                    }`}
                            >
                                {s.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="flex items-center justify-end space-x-2 sm:space-x-3">
                    <button onClick={onPrev} className="px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium text-gray-500 hover:text-gray-700">
                        Back
                    </button>
                    {showNext && onNext && (
                        <button
                            onClick={onNext}
                            className="bg-gray-200 text-gray-900 px-4 sm:px-6 py-1.5 sm:py-2 rounded-xl text-xs sm:text-sm font-bold hover:bg-gray-300 transition-all flex items-center shadow-sm"
                        >
                            {nextLabel} <i className="fas fa-arrow-right ml-1 sm:ml-2 text-xs"></i>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
